module.exports = __webpack_public_path__ + "fonts/Raleway-Bold.0ec2e848.woff2";